var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-svgrepo-com_6_",
    "data-name": "facebook-svgrepo-com (6)",
    transform: "translate(-0.993 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34644",
    "data-name": "Path 34644",
    d: "M30.993,16A15,15,0,1,0,13.657,30.817V20.334h-3.8V16h3.806V12.7c0-3.758,2.238-5.837,5.663-5.837a23,23,0,0,1,3.356.294v3.692H20.787a2.166,2.166,0,0,0-2.442,2.342V16H22.5l-.664,4.335h-3.5V30.817A15,15,0,0,0,30.993,16Z",
    transform: "translate(0 0)",
    fill: "#0866ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34645",
    "data-name": "Path 34645",
    d: "M17.124,17.217l.665-4.337H13.628V10.066a2.167,2.167,0,0,1,2.444-2.343h1.893v-3.7a23.029,23.029,0,0,0-3.359-.294c-3.43,0-5.668,2.079-5.668,5.84v3.308H5.13v4.337H8.94V27.7a15.086,15.086,0,0,0,4.691,0V17.217Z",
    transform: "translate(4.717 3.112)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSvgrepoCom);
export default __webpack_public_path__ + "static/media/facebook-svgrepo-com.4ab53f1df692bb94f8bea6e4cb1e72db.svg";
export { ForwardRef as ReactComponent };